import { Box, Typography } from '@mui/material';
import React from 'react';

export const MatchingPropFieldNumberShow = ({ property }) => {
  const { label, publicLabel, value, unit } = property;

  return (
    <Box className="flex items-start justify-start gap-2">
      <Typography fontWeight={600}>{`${publicLabel || label}: `}</Typography>
      <Typography>{`${value || '-'} ${unit}`}</Typography>
    </Box>
  );
};
